export const constants = {
  storage_keys: {
    locale: 'locale_key',
    auth_token: 'a12244a0-01d8',
  },
};
